// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-16a9ac0f] .partner-logo{margin-bottom:1.5rem}@media(min-width: 62em){[data-v-16a9ac0f] .partner-logo{margin-bottom:2rem;width:21.875rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
